<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Elige el tipo de proyecto que quieras crear</p>
    </header>
    <section class="modal-card-body" >
      <div class = "project-type">
        <div v-for = "t in types" class = "type" v-on:click = "selectProjectType(t.type)" :id = "t.type" :class = "{'selected': selectedProjectType === t.type, 'disabled': !t.enabled}" :key = "t.name">
          <img :src = "t.img"/>
          <span>{{t.name}}</span>
          <p class = "description">{{t.description}}</p>
        </div>
      </div>
      <ClassroomSelectList v-if = "isAuthenticated" @input2="selectClassroom" :user="this.$store.state.user" :alwaysDisplay="false" headerText="Si quieres puedes dejar ya asociado este proyecto a una clase"></ClassroomSelectList>

      <!--
      <div id="recent-projects" v-if="isAuthenticated && projects.length>0"  >
        <h2> Tus últimos proyectos </h2>
         <b-loading :is-full-page="false" :active.sync="loadingProjects" :can-cancel="false"></b-loading>
        <div class="project" v-for="project in projects" :key = "project.id">
          <router-link :to="'/editor/'+project.id" v-on:click.native="$parent.close()">
            <div> {{ project.name }} </div>
          </router-link>
        </div>
      </div>
      -->
    </section>
    <footer class="modal-card-foot">
      <a class="btn" type="button" @click="goBack"> Volver </a>
      <button id = "create" class="btn btn-bg-colored" v-on:click = "createProject"> Crear </button>
    </footer>
  </div>
  <!--
  Se ha generado una URL para tu proyecto.
  <div> http://programalaplaza.medialab-prado.es/editor/{{projectId}}</div>
  ¿has pensado en registrarte en la plataforma? Si trabajas en un proyecto en serio es la mejor forma de no perder tu trabajo.
  <a class="button"  @click="showLogin = true" >login</a>
  -->
</template>
<script>
import ClassroomSelectList from '../UI/ClassroomSelectList'
export default {
  name: 'CreateProject',
  components: {
    ClassroomSelectList
  },
  props: {
  },
  data () {
    return {
      types: [
        { name: 'P5.js (recommendado)', type: 'p5js', img: '/static/img/p5.png', enabled: true },
        { name: 'Three.js', type: 'threejs', img: '/static/img/threejs.png', description: '(Avanzado)', enabled: true },
        { name: 'Processing.js', type: 'processingjs', img: '/static/img/pjs.jpg', description: '(Obsoleto)', enabled: true },
        { name: 'HTML5 Canvas', type: 'html5canvas', img: '/static/img/html5canvas.png', description: '(Avanzado)', enabled: true }
      ],
      selectedProjectType: 'p5js',
      loadingProjects: true,
      selectedClassroom: -1
    }
  },
  computed: {
    isAuthenticated () {
      return this.$store.getters['auth/isAuthenticated']
    },
    projects () {
      if (this.isAuthenticated && this.loadingProjects === false) {
        return this.$store.getters['user/myProjectList'].slice(0).sort(function compare (a, b) {
          var dateA = new Date(a.updated_on)
          var dateB = new Date(b.updated_on)
          return dateB - dateA
        }).slice(0, 4)
      } else return []
    }
  },
  methods: {
    selectClassroom: function (classinfo) {
      this.selectedClassroom = classinfo.id
    },
    selectProjectType: function (type) {
      this.selectedProjectType = type
    },
    createProject: function () {
      let options = { projectType: this.selectedProjectType }
      if (this.selectedClassroom !== -1) {
        options.classroom = this.selectedClassroom
      }
      this.$store.commit('setCreateProjectOptions', options)
      this.$router.push({ name: 'Editor.created' })
      this.$parent.close()
    },
    goBack () {
      this.$parent.close()
      // this.$router.go(-1)
    }

  },
  created () {
    if (this.$store.getters['auth/isAuthenticated']) {
      this.$store.dispatch('user/fetchMyProjects').then(() => {
        this.loadingProjects = false
      })
    }
  }
}
</script>

<style lang = "less" scoped>
@import (reference) "../../assets/styles/main.less";

.project-type {
  .font-code;
  display: flex;
  flex-direction: row;

  .description {
    font-size: small;
  }

  .type {
    flex: 1;
    padding: 12px;
    margin-right: 20px;
    display: flex;
    flex-direction: column;
    text-align: center;
    // border: 5px solid transparent;
    align-items: center;
    border: 3px solid transparent;

    &:hover, &.selected {
      cursor: pointer;
      // border: 5px solid @accentColor;
      border-color: @accentColor;
      border-radius: 3px;
    }

    &.selected {
      background: @accentColor;
    }
  }

  img {
    min-width: 80px;
    height: 80px;
  }

  span {
    padding-top: 10px;
  }
}
/*
.modal-card-foot{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
*/
#recent-projects{
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/Editor/EditorCreateProject.vue